import { ReactElement } from 'react';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';

import { useStoreState } from '~/store/hooks';
import NoDataFound from '~/ui/components/reusable/NoDataFound';
import Item from './Item';

import { IInsurance, IInsurancesSelectors } from '~/services/api/insurances/types';
import { ISectionPermissions } from '../types';

interface IProps {
  insurances: IInsurance[];
  selectors: IInsurancesSelectors;
  permissions: ISectionPermissions;
}

const TableComponent = ({ insurances, selectors, permissions }: IProps): ReactElement => {
  const userId = useStoreState(state => state.auth.currentUser?.id);

  const showActionsColumns =
    permissions.canManage || insurances.some(insurance => insurance.userId === userId);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Group</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Policy Number</TableCell>
            <TableCell>Insurance Type</TableCell>
            <TableCell>Insurance Plan</TableCell>
            <TableCell>Plan Type</TableCell>
            <TableCell width={120}>Expiry Date</TableCell>
            <TableCell width={120}>Authorization Valid Through</TableCell>
            {showActionsColumns && (
              <>
                <TableCell width={60}>Edit</TableCell>
                <TableCell width={60}>Remove</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {insurances.length ? (
            insurances.map(item => (
              <Item
                key={item.id}
                insurance={item}
                selectors={selectors}
                permissions={permissions}
                showActionsColumns={showActionsColumns}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={showActionsColumns ? 10 : 8}>
                <NoDataFound />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableComponent;
